import React from "react";
import styled from "styled-components";

export const HeroImage = styled.img`
    height: 424px;
    width: 668px;
    object-fit: cover;
    display: block;
    margin: auto;
    @media (max-width: 767px){
        height: 227px;
        width: auto;
    }
`;

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;
